// Must be imported before any Cesium module so the base URL is set
// before Cesium attempts to resolve its assets.
// Turbopack has no webpack DefinePlugin equivalent, so we assign the global here.
if (globalThis.window !== undefined) {
  (globalThis as any).CESIUM_BASE_URL = "/static/cesium/";
}
